import React, { memo, useCallback } from 'react';

import { IParsedSearchItem } from '../../types';

export const SearchOption: React.FC<{ data: IParsedSearchItem }> = memo((props) => {
    const { description, text, highlight } = props.data;
    const highlights = highlight && highlight.split(';') || [];

    const highlightTextRanges = (highlights[0] || '').split(',').filter(Boolean);
    const highlightDescriptionRanges = (highlights[1] || '').split(',').filter(Boolean);

    const formatTextChunk = useCallback((textChunk: string, highlightRanges: string[]): React.ReactNode[] => {
        let prevEnd = 0;

        if (!highlightRanges.length) {
            return [textChunk];
        }

        return highlightRanges.reduce<React.ReactNode[]>((acc, highlightRange, index) => {
            const parts = highlightRange.split('-');
            const start = Number(parts[0]);
            const end = Number(parts[1]);

            // if start of textChunk is not highlighted
            if (!acc.length && start > 0) {
                acc.push(textChunk.substring(0, start));
            }

            // text between two highlighted chunks
            if (prevEnd && prevEnd < start) {
                acc.push(textChunk.substring(prevEnd, start));
            }

            acc.push(<b key={highlightRange}>{textChunk.substring(start, end)}</b>);

            // if end of textChunk is not highlighted
            if (index + 1 === highlightRanges.length) {
                acc.push(textChunk.substring(end));
            }

            prevEnd = end;

            return acc;
        }, []);
    }, []);

    return (
        <span>
            {formatTextChunk(text, highlightTextRanges)}
            {description && formatTextChunk(description, highlightDescriptionRanges)}
        </span>
    );
});
